import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "out-of-production-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Nylig utgåtte varer", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OutOfProductionNav = _resolveComponent("OutOfProductionNav")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProductList = _resolveComponent("ProductList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_OutOfProductionNav, { class: "nav" }),
    _createElementVNode("header", null, [
      _hoisted_2,
      _createVNode(_component_Button, {
        color: "secondary",
        type: "inertia-link",
        href: _ctx.route('reports.out-of-production.print', { type: _ctx.type })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            type: "mdi",
            path: _ctx.mdiPrinter
          }, null, 8, ["path"]),
          _createTextVNode(" Skriv ut")
        ]),
        _: 1
      }, 8, ["href"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_ProductList, {
        products: _ctx.products,
        "is-admin": _ctx.isAdmin,
        "show-print-button": false,
        "show-wc-id": false
      }, null, 8, ["products", "is-admin"])
    ])
  ]))
}